export default {
  prev: {
    default: 'Retour',
    toDashboard: 'Tableau de bord'
  },
  next: {
    default: 'Continuer'
  },
}
